import React from "react";
import { ListView } from "../core/ListView";
import LocationCity from "@mui/icons-material/LocationCity";
import { EmptyDetailCard } from "../core/EmptyDetailCard";
import { RoyaltyTotals } from "../royalties/RoyaltyTotals";
import {
  useAllRoyalties,
  useAllRoyaltiesWithoutContract,
  useAllRoyaltiesWithoutEdition,
  useAllRoyaltiesWithoutUnits,
  useMyEntitlements,
} from "@seabrookstudios/pitch2table";
import Business from "@mui/icons-material/Business";
import Money from "@mui/icons-material/Money";
import CalendarMonth from "@mui/icons-material/CalendarMonth";
import Category from "@mui/icons-material/Category";
import Numbers from "@mui/icons-material/Numbers";
import Description from "@mui/icons-material/Description";
import Layers from "@mui/icons-material/Layers";
import Divider from "@mui/material/Divider";
import Notifications from "@mui/icons-material/Notifications";
import { SettingsCategory } from "./Category";
import { LockedCategory } from "../core/HasEntitlements";

export const RoyaltyCategoriesList = ({ onListItemSelected, selectedListItemId }) => {
  const { data: royalties = [] } = useAllRoyalties();
  const { data: withoutUnits = [] } = useAllRoyaltiesWithoutUnits();
  const { data: withoutContract = [] } = useAllRoyaltiesWithoutContract();
  const { data: withoutEdition = [] } = useAllRoyaltiesWithoutEdition();
  const { data: entitlements } = useMyEntitlements();

  const showWithoutUnitsCategory = withoutUnits.length > 0 && royalties.length !== withoutUnits.length;
  const showWithoutContractCategory = withoutContract.length > 0 && royalties.length !== withoutContract.length;
  const showWithoutEditionCategory = withoutEdition.length > 0 && royalties.length !== withoutEdition.length;

  return (
    <ListView title="Royalty Categories" Filters={null} Action={undefined} EmptyList={EmptyDetailCard} neverEmpty>
      <RoyaltyTotals royalties={royalties} />
      {!entitlements?.isMember ? (
        <LockedCategory
          category="Royalty Reminders"
          helperText="View your scheduled royalty reminders"
          Icon={Notifications}
        />
      ) : (
        <SettingsCategory
          category="Royalty Reminders"
          id="reminders"
          helperText="View your scheduled royalty reminders"
          selected={selectedListItemId === "reminders"}
          onClick={onListItemSelected}
          badgeCount={0}
          Icon={Notifications}
        />
      )}
      <SettingsCategory
        category="View all"
        id="all"
        helperText="View all royalties"
        selected={selectedListItemId === "all"}
        onClick={onListItemSelected}
        badgeCount={0}
        Icon={Money}
      />
      <SettingsCategory
        category="View unpaid"
        id="unpaid"
        helperText="View only unpaid royalties"
        selected={selectedListItemId === "unpaid"}
        onClick={onListItemSelected}
        badgeCount={0}
        Icon={Money}
      />
      <SettingsCategory
        category="By Year"
        id="by-year"
        helperText="View all royalties grouped by year"
        selected={selectedListItemId === "by-year"}
        onClick={onListItemSelected}
        badgeCount={0}
        Icon={CalendarMonth}
      />
      <SettingsCategory
        category="By Game"
        id="by-game"
        helperText="View royalties grouped by game"
        selected={selectedListItemId === "by-game"}
        onClick={onListItemSelected}
        badgeCount={0}
        Icon={LocationCity}
      />
      <SettingsCategory
        category="By Publisher"
        id="by-publisher"
        helperText="View royalties grouped by publisher"
        selected={selectedListItemId === "by-publisher"}
        onClick={onListItemSelected}
        badgeCount={0}
        Icon={Business}
      />
      <SettingsCategory
        category="By Type"
        id="by-type"
        helperText="View royalties grouped by type"
        selected={selectedListItemId === "by-type"}
        onClick={onListItemSelected}
        badgeCount={0}
        Icon={Category}
      />
      <Divider />
      {showWithoutUnitsCategory && (
        <SettingsCategory
          category="View royalties without units"
          id="without-units"
          helperText="Royalties missing units"
          selected={selectedListItemId === "without-units"}
          onClick={onListItemSelected}
          badgeCount={0}
          Icon={Numbers}
        />
      )}
      {showWithoutContractCategory && (
        <SettingsCategory
          category="View royalties without contract"
          id="without-contract"
          helperText="Royalties not linked to a contract"
          selected={selectedListItemId === "without-contract"}
          onClick={onListItemSelected}
          badgeCount={0}
          Icon={Description}
        />
      )}
      {showWithoutEditionCategory && (
        <SettingsCategory
          category="View royalties without edition"
          id="without-edition"
          helperText="Royalties not linked to an edition"
          selected={selectedListItemId === "without-edition"}
          onClick={onListItemSelected}
          badgeCount={0}
          Icon={Layers}
        />
      )}
    </ListView>
  );
};
